module.exports = __webpack_public_path__ + "static/media/multiply.764471c5.svg";